export default [
    {
      path: '/promotions',
      name: 'promotions-read',
      component: () => import('@/views/promotions/promotions-list/PromotionsList.vue'),
      meta: {
        resource: 'Promotions',
        action: 'read',
      },
    },
    {
      path: '/promotions/create',
      name: 'promotions-create',
      component: () => import('@/views/promotions/promotions-form/PromotionsForm.vue'),
      meta: {
        resource: 'Promotions',
        action: 'create',
      },
  },
  ]
  